import React from "react";

import "./SidebarRight.scss";

import OberinCalendar from "../../components/Layout/Sidebar/OberinCalendar/OberinCalendar";
import LatestPosts from "../../components/Layout/Sidebar/LatestPosts/LatestPosts";
import SocialMediaLinks from "../../components/Layout/Sidebar/SocialMediaLinks/SocialMediaLinks";

interface Props {}

const SidebarRight: React.FC<Props> = React.memo(() => {
    return (
        <section id="sidebar-right" className="d-none d-lg-block">
            {/* Calendar */}
            <OberinCalendar />

            {/* Latest Forum Posts */}
            <div className="w-100 px-2 py-1">
                <div className="box-shadow">
                    <div className="title-bar px-2">Last Forum Posts</div>
                    <div className="recent-post-container bg-light-gray bl-xs br-xs bb-xs">
                        <LatestPosts collapse={() => {}} />
                    </div>
                </div>
            </div>

            {/* Social Media */}
            <div className="w-100 px-2 pt-1">
                <div className="box-shadow">
                    <div className="title-bar px-2">Social media</div>
                    <nav
                        className="bg-light-gray p-1 bl-xs br-xs bb-xs d-flex flex-column"
                        aria-label="Social media links"
                    >
                        <SocialMediaLinks />
                    </nav>
                </div>
            </div>
        </section>
    );
});

export default SidebarRight;
